export const PLAN_STORAGE_KEY = 'atozas_subscription_plan';
export const UPGRADE_POPUP_KEY = 'atozas_upgrade_popup_seen';
export const YEARLY_PLAN_ID = 'yearly';

export const getCurrentSubscriptionPlan = () => {
  return localStorage.getItem(PLAN_STORAGE_KEY) || null;
};

export const isYearlyPlanActive = () => getCurrentSubscriptionPlan() === YEARLY_PLAN_ID;

export const shouldHideSubscriptionButton = () => isYearlyPlanActive();
